import script from "./TableCell.vue?vue&type=script&setup=true&lang=js"
export * from "./TableCell.vue?vue&type=script&setup=true&lang=js"

import "./TableCell.vue?vue&type=style&index=0&id=66c564c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66c564c7"]])

export default __exports__